import * as React from "react";
import { useBulkAddNotesForSecurityEvents } from "security-app/hooks/useSecurityEventsAPI";
import AddNotesModal from "security-app/components/SecurityEvents/Alerts/AlertsModals/AddNotesModal/AddNotesModal";
import useSendEventActionTelemetry from "components/events/events/hooks/useSendEventActionTelemetry";
import useRefetchTable from "security-app/components/SecurityEvents/Alerts/AlertsModals/UsersModal/useRefetchTable";
import useDeselectEntities from "common/hooks/useDeselectEntities";
const AddNotesBulk = ({ eventIds, onClose, show }) => {
  const { addNotes } = useBulkAddNotesForSecurityEvents();
  const refetch = useRefetchTable();
  const sendEventActionTelemetry = useSendEventActionTelemetry();
  const deselectEntities = useDeselectEntities();
  const onConfirm = async (notes) => {
    await addNotes({ ids: eventIds, notes });
    sendEventActionTelemetry("ADD_NOTES", true);
    refetch();
    deselectEntities(eventIds);
    onClose();
  };
  return show ? /* @__PURE__ */ React.createElement(AddNotesModal, { closeModal: onClose, onConfirm, show: true }) : null;
};
export default AddNotesBulk;
